





















































































































import { fetchSolicitudBaja } from '../fetchSolicitudBaja';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import moment from 'moment';
import Vue from 'vue';
import { AxiosVue } from '@/AxiosVue'; //
import { ServicioProxy } from '@/config/enums'; //
import config from '@/config/index'; //
import { ComponenteBaseStepper } from '@/views/base/ComponenteBaseStepper';
import { Component, Prop, Emit, Watch } from 'vue-property-decorator';
import { EstadoInterface } from '@/interfaces/Estado';
import { LoadingService } from '@/services/loadingService';
import { EstadoEntidad } from '@/config/enums';
import { EstadosService } from '@/services/estadosService';
import { Validator } from 'vee-validate';
import { PermisoAccionVm } from '@/views/base/PermisoAccionVm';
import { Funcionalidades } from '@/config/funcionalidades';
import { CodigoAccion } from '@/views/base/VariablesPermisos';
import { IFuncionalidad } from '@/interfaces/Funcionalidad';
import { AccionesInterface, IAccionesPadre } from '@/interfaces/Acciones';
import {
  GridApi,
  ColumnApi,
  ColDef,
  CellContextMenuEvent,
  GridReadyEvent,
  SelectionChangedEvent,
  SelectionController,
  RowNode,
  CellClickedEvent,
  RowSelectedEvent,
  CellClassParams,
} from 'ag-grid-community';
import { differenceBy } from 'lodash';
import Confirmation from '@/components/Confirmation.vue';
import DatosGenerales from './DatosGenerales.vue';
import DetalleClientes from './DetalleClientes.vue';

@Component({
  components: {
    DatePicker,
    'app-confirmacion': Confirmation,
    DatosGenerales,
    DetalleClientes,
  },
})
export default class CrearSolicitud extends ComponenteBaseStepper {
  @Prop({ default: false }) motivos: any;
  @Prop({ required: true }) clientes: any;
  desactivarBoton: boolean = true;
  modalGeneral: any;
  modalDetalles: any;

  mounted() {
    this.modalGeneral = this.$refs.datosGenerales;
    this.modalDetalles = this.$refs.datosDetallados;
  }

  cantEquipos: number = 0;
  cantPerifericos: number = 0;

  actualizarInformacion(data: any) {
    this.cantEquipos = data.reduce((acumulador: number, objeto: any) => {
      return acumulador + Number(objeto.equipos);
    }, 0);
    this.cantPerifericos = data.reduce((acumulador: number, objeto: any) => {
      return acumulador + Number(objeto.perifericos);
    }, 0);
    let cantClientes: number = data.length;
    this.modalGeneral.actualizarCantidades(
      this.cantEquipos,
      this.cantPerifericos,
      cantClientes
    );
  }

  // permisos
  permisosActuales: PermisoAccionVm[] = [];

  // Declarar todas las posibles subAcciones
  datosGenerales: PermisoAccionVm = {
    accion: 'Datos Generales',
    visible: false,
    step: 1,
    codigoAccionPadre: CodigoAccion.Crear,
  };

  detalleClientes: PermisoAccionVm = {
    accion: 'Detalles Clientes',
    visible: false,
    step: 2,
    codigoAccionPadre: CodigoAccion.Crear,
  };

  permisosTotales: PermisoAccionVm[] = [
    this.datosGenerales,
    this.detalleClientes,
  ];

  nextGeneral() {
    !this.datosGenerales.visible;
    !this.detalleClientes.visible;
    this.e1 = 2;
    this.actual--;
  }

  async CrearMovimientos(data: string) {
    if (data == 'next') {
      if (this.modalDetalles.ordesList.length == 0) {
        this.$snotify.error('Por favor, cree al menos una solicitud', {
          timeout: 3000,
        });
        return;
      }
      let crearGeneral = await this.modalGeneral.crearDato();
      if (!crearGeneral) {
        return;
      }
      let detalles = await this.modalDetalles.crearDato(
        this.modalGeneral.formFields.numero.value
      );

      if (detalles) {
        this.$snotify.success('Solicitud creada con exito', {
          timeout: 3000,
        });
        this.closeModal(false);
      }
    } else {
      !this.datosGenerales.visible;
      !this.detalleClientes.visible;
      this.e1 = 1;
      this.actual++;
    }
  }

  // Globales
  $snotify: any;
  e1: number = 1;
  actual: number = 1;
  btnText: string = 'Continuar';
  btnClass: string = 'btn-continuar';
  dialog: boolean = true;
  validForm: boolean = false;
  loadingService = new LoadingService();
  btnBloquear: boolean = false;
  dialogConfirmacion: boolean = false;
  dialogConfirmacionClose: boolean = false;
  mensajeConfirmacion: any = '';

  //controllers
  readonly controller: string = 'funcionalidad';
  readonly controllerAccion: string = 'accion';
  readonly controllerModuloAccion: string = 'ModuloAccion';
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);

  //@Watch('show')
  async onPropertyChanged(value: boolean, oldValue: boolean) {
    this.dialog = value; //Estado Activo0
  }

  closeModal(val: boolean) {
    document.getElementById('cardDivModulos').scrollIntoView(true);
    this.e1 = 1;
    this.dialog = false;
    this.btnText = 'Continuar';
    this.btnClass = 'btn-continuar';
    this.$emit('modalAsociacionEmit', false);
  }

  confirmCallbackConfirm(val: boolean) {
    this.dialogConfirmacionClose = false;
    if (val) {
      this.closeModal(false);
    }
  }

  cierraMenu() {
    var appBanners = document.getElementsByClassName(
      'ag-menu'
    ) as HTMLCollectionOf<HTMLElement>;
    if (appBanners.length > 0) {
      appBanners[0].remove();
    }
  }
}
